
    import {BaseMixins, Prop, Component} from "@/lib";
    import TransferTree from "@/components/transfer-tree/transfer-tree.vue";
    import Tree from "@/store/shared/entity/tree";
    @Component({components:{TransferTree}})
    export default class TreeModal extends BaseMixins{
        @Prop({ type: Boolean, default: false }) value: boolean;
        @Prop({ type: String, default:"Action.Choose"} ) modalTitleL: string; //Modal Title
        @Prop({ type: Boolean, default: true }) multiple: boolean; //是否多选 默认是
        @Prop({ type: Array, default: function() { return []; } }) checkedIds: Array<number>; //已选
        @Prop({ type: String }) queryAction:string; //数据源dispatch type
         @Prop({ type: Array }) storeState:Array<any>;

        tempTargetKeys = [];
        tempTargetData = [];

        listStyle = {
            "width":"250px",
            "height":"300px"
        }

        get treeData(){
            if(this.storeState)
                return this.storeState;
            return [];
        }

        async visibleChange(value) {
            if (value) {
                this.setTempTargetKeys();
                await this.query();
                this.tempTargetData= [];
                this.loadCheckedData(this.treeData);
            }
        }

        loadCheckedData(parent:Array<any>){
            parent.forEach(item => {
                if(!!item.children && item.children.length > 0){
                    this.loadCheckedData(item.children);
                }else{
                    if(this.tempTargetKeys.indexOf(item.key) > -1){
                        let itemData = {key: item.key, title: item.title };
                        if(!this.tempTargetData.some(el => { return el.key == itemData.key})){
                            this.tempTargetData.push(itemData);
                        }
                    }
                }
            });
        }

        setTempTargetKeys() {
            if(this.checkedIds && this.checkedIds.length > 0){
                this.tempTargetKeys = this.checkedIds;
            }
        }

        async query() {
            await this.$store.dispatch({ type: this.queryAction,  data: {  checkIdList:[], keyword: ''}  });
        }

        transferChange(newTargetData, newTargetKeys, direction, moveKeys){
            this.tempTargetKeys = newTargetKeys;
            this.tempTargetData = newTargetData;
        }

        //确认选择操作
        confirm() {
            if(this.tempTargetData.length == 0){
                this.$Message.warning({
                    content: this.L("Validate.PleaseSelect"),
                    duration: 3
                });
                return;
            }
            let tempData = this.tempTargetData.map(item => { return JSON.stringify({key:item.key, title: item.title })});
            tempData = Array.from(new Set(tempData));
            let data = tempData.map(item => { return JSON.parse(item) });
            if (!this.multiple && data.length > 1) {
                this.$Message.warning({
                    content: this.L("Validate.OnlySelectOneRecord"),
                    duration: 3
                });
                return;
            }
            this.tempTargetKeys = [];
            this.$emit("confirm-callback", data);
        }

        cancel() {
            this.tempTargetKeys = [];
            this.$emit("cancel-callback");
        }
    }
